module.exports = __webpack_public_path__ + "static/media/condominium.30034348.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/condominium.svg
// module id = 539
// module chunks = 0